import React, { useContext } from 'react';
import { toJS } from 'mobx';
import { StoreContext } from 'index';
import { useObserver, useLocalStore } from 'mobx-react'; // 6.x or mobx-react-lite@1.4.0

function useEmployeeId(props) {
  const store = useContext(StoreContext);
  const userStore = toJS(store.userStore);
  return useObserver(() => ({
    employeeId: userStore?.defaultRestaurant?.value,
    defaultRestaurant: userStore?.defaultRestaurant?.label,
    timeZone: userStore?.defaultRestaurant?.timeZone,
  }));
}

export default useEmployeeId;
